import { Bell, User, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Dropdown, DropdownItem } from '@components/ui';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { logout } from '@features/auth/authSlice';
import { useLogoutMutation } from '@features/auth/authApi';
import { useSidebar } from '@hooks/useSidebar';
import { memo, useCallback } from 'react';
import styles from '@/styles/layout/Header.module.scss';

const Header = memo(() => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const { isExpanded } = useSidebar();

  const [logoutApi] = useLogoutMutation();

  const handleProfile = useCallback(() => {
    void navigate('/profile');
  }, [navigate]);

  const handleLogout = useCallback(() => {
    void logoutApi().finally(() => {
      dispatch(logout());
      void navigate('/login');
    });
  }, [logoutApi, dispatch, navigate]);

  return (
    <header
      className={styles.header}
      style={{ left: isExpanded ? '256px' : '64px' }}
    >
      <div className={styles.inner}>
        <div className={styles.actions}>
          {/* Notifications */}
          <button className={styles.notifBtn}>
            <Bell className="h-5 w-5" />
            <span className={styles.notifDot} />
          </button>

          {/* Profile Dropdown */}
          <Dropdown
            trigger={
              <div className={styles.profileTrigger}>
                <Avatar
                  size="sm"
                  fallback={user ? `${user.first_name} ${user.last_name}` : 'Admin User'}
                  src={undefined}
                />
                <div className={styles.profileInfo}>
                  <p className={styles.profileName}>
                    {user ? `${user.first_name} ${user.last_name}` : 'Admin User'}
                  </p>
                  <p className={styles.profileRole}>
                    {user?.role?.name?.toUpperCase() || 'Administrator'}
                  </p>
                </div>
              </div>
            }
            align="right"
          >
            <div className={styles.dropdownHeader}>
              <p className={styles.dropdownHeaderName}>{user?.email || 'Admin User'}</p>
              <p className={styles.dropdownHeaderEmail}>{user?.email || 'admin@example.com'}</p>
            </div>
            <div className={styles.dropdownBody}>
              <DropdownItem onClick={handleProfile} icon={<User className="h-4 w-4" />}>
                Profile
              </DropdownItem>
              <DropdownItem
                onClick={handleLogout}
                icon={<LogOut className="h-4 w-4" />}
                className={styles.logoutItem}
              >
                Logout
              </DropdownItem>
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;
